import { get } from 'lodash';

import { TCustomerFields } from 'modules/checkout/presentation/constants';
import { ICustomer } from 'shared/domain/entities';

type TAddressFieldPair = {
  guardianPath: TCustomerFields;
  customerPath: TCustomerFields;
};

const ADDRESS_FIELD_PAIRS: TAddressFieldPair[] = [
  {
    guardianPath: 'guardian.address.postalCode',
    customerPath: 'address.postalCode',
  },
  {
    guardianPath: 'guardian.address.city.id',
    customerPath: 'address.city.id',
  },
  {
    guardianPath: 'guardian.address.district.id',
    customerPath: 'address.district.id',
  },
  {
    guardianPath: 'guardian.address.street',
    customerPath: 'address.street',
  },
  {
    guardianPath: 'guardian.address.number',
    customerPath: 'address.number',
  },
];

type TGuardianAddressCopy = Array<[TCustomerFields, unknown]>;

// Only offered while the guardian address is being filled in the same form.
// Empty guardian values are copied too, so the customer never keeps a district
// or a street that belongs to another city.
export default function getGuardianAddressCopy(
  values: Partial<ICustomer>,
  fields: TCustomerFields[],
  savedCustomer?: Partial<ICustomer>,
): TGuardianAddressCopy {
  const isGuardianAddressAsked = ADDRESS_FIELD_PAIRS.some(({ guardianPath }) =>
    fields.includes(guardianPath),
  );

  if (!isGuardianAddressAsked) return [];

  return ADDRESS_FIELD_PAIRS.reduce<TGuardianAddressCopy>(
    (copy, { guardianPath, customerPath }) => {
      if (!fields.includes(customerPath)) return copy;

      const guardianValue = fields.includes(guardianPath)
        ? get(values, guardianPath)
        : get(savedCustomer, guardianPath);

      if (guardianValue === undefined) return copy;

      return [...copy, [customerPath, guardianValue]];
    },
    [],
  );
}
